import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const LAST_PAGES_URL = BASE_URL + ENDPOINT_ROUTES.protocols + "/last-pages";

const errorMessage = (xhr) => {
  if (xhr.status === 0)
    return navigator.onLine
      ? "Nie można połączyć się z serwerem."
      : "Brak połączenia z Internetem.";

  return xhr.responseText || "Wystąpił nieznany błąd.";
};

const request = (options, callback) =>
  $.ajax({
    contentType: "application/json; charset=utf-8",
    ...options,
    success: function (response) {
      callback({ success: true, content: response });
    },
    error: function (xhr) {
      callback({ success: false, status: xhr.status, error: errorMessage(xhr) });
    },
  });

const api = {
  // Lista szablonów: [{ id, name, is_default, version_id, version }]
  getAll: (callback) => request({ url: LAST_PAGES_URL, type: "GET" }, callback),

  // Aktualna wersja szablonu razem z sekcjami.
  get: (id, callback) =>
    request({ url: LAST_PAGES_URL + "/" + id, type: "GET" }, callback),

  // Nowy szablon - backend tworzy od razu wersję 1.
  create: (data, callback) =>
    request(
      { url: LAST_PAGES_URL, type: "POST", data: JSON.stringify(data) },
      callback,
    ),

  // Każdy zapis odkłada nową wersję.
  save: (id, data, callback) =>
    request(
      { url: LAST_PAGES_URL + "/" + id, type: "PUT", data: JSON.stringify(data) },
      callback,
    ),
};

const lastPagesApi = { api };

export default lastPagesApi;
